
angular.module('webremote.directive.objectmanager.views')
  .controller('webremote.directive.objectmanager.views.default.controller', ['$scope', '$transclude', 'objectManagerService', 'httpService', '$uibModal', function ($scope, $transclude, objectManagerService, httpService, $uibModal) {

  }])

  .directive('omViewDefault', function () {
    return {
      restrict: 'E',
      transclude: {
        title: '?omViewTitle',
        content: 'omViewContent',
        icon: '?omViewIcon'
      },
      scope: {
        omViewSchema: '=omViewSchema'
      },
      templateUrl: 'directives/objectmanager/views/default/template.html'
    }
  })
